import { ChevronDownIcon, ChevronRightIcon } from 'lucide-react';

import type {
  QueryFolderData,
  QueryFolderType,
} from '@/sections/insights/queryBuilder/savedQueries/folders';

export interface QueryFolderHeaderProps {
  folderData: QueryFolderData;
  queryCount: number;
  isExpanded: boolean;
  onFolderClick: (folderId: QueryFolderType) => void;
}

/**
 * QueryFolderHeader - Header component for QueryFolder
 *
 * Renders the folder header button with:
 * - Folder icon
 * - Folder label
 * - Query count badge (when > 0)
 * - Expand/collapse chevron
 */
export const QueryFolderHeader = ({
  folderData,
  queryCount,
  isExpanded,
  onFolderClick,
}: QueryFolderHeaderProps) => {
  const Icon = folderData.icon;

  return (
    <button
      onClick={() => onFolderClick(folderData.id)}
      className="hover:bg-chariot-background-secondary flex w-full items-center gap-3 px-4 py-3 text-left transition-colors"
      data-testid={`folder-header-${folderData.id}`}
      aria-label={`${folderData.label} folder (${queryCount} queries)`}
      aria-expanded={isExpanded}
    >
      <Icon className="text-chariot-text-secondary size-4 shrink-0" />
      <span className="text-chariot-text-primary flex-1 text-sm font-medium">
        {folderData.label}
      </span>
      {queryCount > 0 && (
        <span className="text-chariot-text-secondary mr-2 text-xs">
          {queryCount}
        </span>
      )}
      {isExpanded ? (
        <ChevronDownIcon className="text-chariot-text-secondary size-4 shrink-0" />
      ) : (
        <ChevronRightIcon className="text-chariot-text-secondary size-4 shrink-0" />
      )}
    </button>
  );
};
